import { getRouteApi } from '@tanstack/react-router';
import { useCallback } from 'react';

import { definedSearchParams } from '@/lib/search-params';

import { NotificationsScreen } from './NotificationsScreen';
import type { NotificationsSearch } from './notifications-search';

const route = getRouteApi('/notifications');

export function NotificationsRoute() {
  const search = route.useSearch();
  const navigate = route.useNavigate();
  const onSearchChange = useCallback(
    (next: NotificationsSearch) => {
      void navigate({ replace: true, search: () => definedSearchParams(next) });
    },
    [navigate],
  );
  return <NotificationsScreen search={search} onSearchChange={onSearchChange} />;
}
